import Vue from 'vue';

Vue.component('staff-role-index', () => import('./staff-role-index.vue'));
